import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import gsap from "gsap";

const Navbar = () => {
  const overlayRef = useRef(null);
  const linksRef = useRef([]);
  const [isOpen, setIsOpen] = useState(false);
  const tl = useRef(null);

  const menuItems = [
        { name: "Home", path: "/" },

    { name: "Gallery", path: "/Getphoto" },
    { name: "Device", path: "/Device" },
    { name: "Capture", path: "/TryNow" },
    {name: "Spin & Win", path: "/SpinWin"},
    { name: "Contact us", path: "/Contact" },
  ];

  useEffect(() => {
    tl.current = gsap.timeline({ paused: true });

    // Start with overlay hidden
    gsap.set(overlayRef.current, {
      clipPath: "polygon(0 0, 100% 0, 100% 0, 0 0)",
    });
    gsap.set(linksRef.current, { y: 100, opacity: 0 });

    tl.current
      .to(overlayRef.current, {
        duration: 1,
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
        ease: "power4.inOut",
      })
      .to(
        linksRef.current,
        {
          y: 0,
          opacity: 1,
          stagger: 0.2,
          duration: 0.8,
          ease: "power4.out",
        },
        "-=0.8"
      );
  }, []);

  const toggleMenu = () => {
    if (!isOpen) {
      tl.current.play();
      document.body.style.overflow = "hidden"; // Lock scroll
    } else {
      tl.current.reverse();
      document.body.style.overflow = "auto"; // Unlock scroll
    }
    setIsOpen(!isOpen);
  };

  return (
    <header className="fixed top-0 w-full z-50">
      <nav className="flex items-center justify-between w-[90%] mx-auto h-20 relative z-50">
        {/* Logo */}
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Logo" className="h-12 w-auto" />
          </Link>
        </div>

        {/* Hamburger */}
        <div
          className="w-12 h-12 flex flex-col justify-center items-center gap-2 cursor-pointer  rounded-lg relative z-50"
          onClick={toggleMenu}
        >
          <span
            className={`block h-1 w-7 bg-[#ffffff] transition-transform ${
              isOpen ? "rotate-45 translate-y-2" : ""
            }`}
          ></span>
          <span
            className={`block h-1 w-7 bg-[#ffffff] transition-opacity ${
              isOpen ? "opacity-0" : ""
            }`}
          ></span>
          <span
            className={`block h-1 w-7 bg-[#ffffff] transition-transform ${
              isOpen ? "-rotate-45 -translate-y-2" : ""
            }`}
          ></span>
        </div>
      </nav>

{/* Overlay */}
<div
  ref={overlayRef}
  className="fixed inset-0 bg-black z-40"
  style={{ clipPath: "polygon(0 0, 100% 0, 100% 0, 0 0)" }}
>
  <ul className="flex flex-col justify-center items-center h-full gap-8 md:gap-12 relative w-full">
    {menuItems.map((item, i) => (
      <li
        key={i}
        ref={(el) => (linksRef.current[i] = el)}
        className="relative cursor-pointer w-full flex justify-center"
      >
        {/* Faded background duplicate */}
        <span className="absolute inset-0 flex justify-center items-center text-white/10 font-bold select-none pointer-events-none z-0 
          text-[3rem] sm:text-[4rem] md:text-[6rem] min-w-[16rem] sm:min-w-[20rem] md:min-w-[24rem]"
        >
          {item.name}
        </span>

        {/* Main link */}
        <Link
          to={item.path}
          className="relative text-white text-3xl sm:text-4xl md:text-5xl font-bold tracking-wide hover:text-[#76cfff] transition-all duration-300 z-10"
        >
          {item.name}
        </Link>
      </li>
    ))}
  </ul>
</div>
    </header>
  );
};

export default Navbar;
// __________________________________________________________
// src/components/Navbar/Nav.jsx
// import React, { useEffect, useRef, useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import gsap from "gsap";
// import logo from "../../assets/images/logo.png";

// const bgImages = [
//   "https://ik.imagekit.io/kg2nszxjp/travel-menu/bg-1.webp",
//   "https://ik.imagekit.io/kg2nszxjp/travel-menu/bg-2.webp",
//   "https://ik.imagekit.io/kg2nszxjp/travel-menu/bg-3.webp",
//   "https://ik.imagekit.io/kg2nszxjp/travel-menu/bg-4.webp",
//   "https://ik.imagekit.io/kg2nszxjp/travel-menu/bg-5.webp",
//   "https://ik.imagekit.io/kg2nszxjp/travel-menu/bg-6.webp",
// ];

// const Navbar = () => {
//   const overlayRef = useRef(null);
//   const bgContainerRef = useRef(null);
//   const linksRef = useRef([]);
//   const toggleRef = useRef(null);
//   const [isOpen, setIsOpen] = useState(false);
//   const timelineRef = useRef(null);
//   const location = useLocation();

//   const menuItems = [
//     { name: "GALLERY", path: "/Getphoto" },
//     { name: "DEVICE", path: "/Device" },
//     { name: "CAPTURE", path: "/TryNow" },
//     { name: "CONTACT US", path: "/Contact" },
//   ];

//   // Close when route changes
//   useEffect(() => {
//     if (isOpen) {
//       timelineRef.current?.reverse();
//       setIsOpen(false);
//       document.body.style.overflow = "auto";

//       const overlay = overlayRef.current;
//       if (overlay) {
//         overlay.style.pointerEvents = "none";
//         overlay.style.opacity = 0;
//       }
//     }
//   }, [location]);

//   useEffect(() => {
//     const overlay = overlayRef.current;
//     const bgContainer = bgContainerRef.current;
//     const toggle = toggleRef.current;

//     if (!overlay || !bgContainer || !toggle) return;

//     const bgImgs = bgContainer.querySelectorAll("img");

//     // Initial states
//     gsap.set(overlay, {
//       opacity: 0,
//       pointerEvents: "none",
//       clipPath: "polygon(0 0, 100% 0, 100% 0, 0 0)",
//     });

//     gsap.set(bgImgs[0], { opacity: 1 });
//     for (let i = 1; i < bgImgs.length; i++) {
//       gsap.set(bgImgs[i], { opacity: 0 });
//     }

//     gsap.set(linksRef.current, { y: 50, opacity: 0 });

//     const tl = gsap.timeline({ paused: true });

//     // Overlay open animation
//     tl.to(overlay, {
//       opacity: 1,
//       pointerEvents: "auto",
//       clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
//       duration: 0.8,
//       ease: "power3.out",
//     })
//       .to(bgImgs, { scale: 1.1, duration: 1, ease: "power3.out" }, 0)
//       .to(
//         linksRef.current,
//         {
//           y: 0,
//           opacity: 1,
//           stagger: 0.1,
//           duration: 0.6,
//           ease: "power3.out",
//         },
//         0.3
//       );

//     timelineRef.current = tl;

//     const toggleHandler = () => {
//       if (isOpen) {
//         tl.reverse();
//         document.body.style.overflow = "auto";

//         tl.eventCallback("onReverseComplete", () => {
//           overlay.style.opacity = 0;
//           overlay.style.pointerEvents = "none";
//         });
//       } else {
//         tl.play();
//         document.body.style.overflow = "hidden";
//       }

//       setIsOpen(!isOpen);
//     };

//     toggle.addEventListener("click", toggleHandler);

//     return () => {
//       toggle.removeEventListener("click", toggleHandler);
//       tl.kill();
//       document.body.style.overflow = "auto";
//     };
//   }, []);

//   // Hover BG swap
//   const handleMouseEnter = (i) => {
//     const bgImgs = bgContainerRef.current?.querySelectorAll("img");
//     if (!bgImgs) return;

//     gsap.to(bgImgs, { opacity: 0, duration: 0.4 });
//     gsap.to(bgImgs[i + 1] || bgImgs[0], {
//       opacity: 1,
//       scale: 1.15,
//       duration: 0.6,
//       ease: "power3.out",
//     });
//   };

//   const handleMouseLeave = () => {
//     const bgImgs = bgContainerRef.current?.querySelectorAll("img");
//     if (!bgImgs) return;

//     gsap.to(bgImgs, { opacity: 0, scale: 1, duration: 0.4 });
//     gsap.to(bgImgs[0], { opacity: 1, duration: 0.5 });
//   };

//   return (
//     <>
//       {/* Overlay */}
//       <div
//         ref={overlayRef}
//         className="fixed inset-0 z-[9999] opacity-0 pointer-events-none"
//       >
//         {/* BG */}
//         <div
//           ref={bgContainerRef}
//           className="absolute inset-0 bg-[#ffdcac]"
//         >
//           {bgImages.map((src, i) => (
//             <img
//               key={i}
//               src={src}
//               alt=""
//               className="absolute w-full h-full object-cover"
//             />
//           ))}
//         </div>

//         {/* Panel */}
//         <div className="absolute right-0 top-0 w-1/2 h-full bg-black/20 backdrop-blur-3xl flex flex-col items-center justify-center gap-8 px-6">
//           {menuItems.map((item, i) => (
//             <Link
//               key={item.path}
//               to={item.path}
//               ref={(el) => (linksRef.current[i] = el)}
//               onMouseEnter={() => handleMouseEnter(i)}
//               onMouseLeave={handleMouseLeave}
//               className="text-[#fff7e8] font-['Anton'] text-[clamp(2rem,6vw,4rem)] tracking-tight hover:text-white transition"
//             >
//               {item.name}
//             </Link>
//           ))}
//         </div>
//       </div>

//       {/* Navbar */}
//       <header className="fixed top-5 left-0 right-0 z-[9998] px-6">
//         <nav className="flex justify-between items-center max-w-[1440px] mx-auto">
//           <Link to="/" className="w-[70px]">
//             <img src={logo} className="w-full" />
//           </Link>

//           <div
//             ref={toggleRef}
//             className="w-11 h-11 flex flex-col justify-center items-center gap-1.5 bg-[#fff0dc] rounded-xl cursor-pointer"
//           >
//             <span className="w-7 h-0.5 bg-[#2f2411]"></span>
//             <span className="w-7 h-0.5 bg-[#2f2411]"></span>
//           </div>
//         </nav>
//       </header>
//     </>
//   );
// };

// export default Navbar;
